import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../../../components/common/LanguageSwitcher';
import { UndrawIllustration } from '../../../components/common/UndrawIllustration';
import { withAreaPrefix } from '../../../lib/area-routes';

export function UnauthorizedPage() {
  const location = useLocation();
  const { t } = useTranslation('auth');

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-background px-4">
      <div className="absolute top-4 right-4 sm:top-6 sm:right-6">
        <LanguageSwitcher />
      </div>
      <div className="flex max-w-lg flex-col items-center px-6 text-center">
        <UndrawIllustration
          scene="access-denied"
          title={t('unauthorized.title')}
          className="mb-6 h-48 w-full max-w-sm"
        />
        <h1 className="mb-2 text-2xl font-semibold text-foreground">{t('unauthorized.title')}</h1>
        <p className="mb-6 text-muted-foreground">{t('unauthorized.message')}</p>
        <Link
          to={withAreaPrefix('/dashboard', location.pathname)}
          className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          {t('unauthorized.back_to_dashboard')}
        </Link>
      </div>
    </div>
  );
}
